<template>
    <transition name="fade">
        <div v-if="isShowing" class="root-animation-div">
            <div class="modal-container" v-on:click="close">
                <div class="horizontal">
                    <div class="modal-content" v-on:click.stop>

                        <div class="header">
                            <div class="title">{{title}}</div>
                            <div class="divider-container">
                                <div class="divider"></div>
                            </div>
                            <div class="log-in-with">{{l10nLogInWith}}</div>
                            <div class="social-login-buttons">
                                <jabra-btn :ref="googleSignInButtonRefName" @jbr-click="onGoogleLoginButtonClick()">
                                    <div class="social-login-button-text">
                                        <span v-if="isGoogleLoginLoading" class="spinner">
                                            <font-awesome-icon :icon="['fal', 'spinner-third']" spin/>
                                        </span>
                                        <span v-else>Google</span>
                                    </div>
                                </jabra-btn>

                                <jabra-btn @jbr-click="onFacebookLoginButtonClick()">
                                    <div class="social-login-button-text">
                                        <span v-if="isFacebookLoginLoading" class="spinner">
                                            <font-awesome-icon :icon="['fal', 'spinner-third']" spin/>
                                        </span>
                                        <span v-else>Facebook</span>
                                    </div>
                                </jabra-btn>
                            </div>
                        </div>
                        <div class="body">
                            <div>{{l10nOr}}</div>
                            <div class="register-form">
                                <form @submit.prevent="handleSubmit" novalidate>
                                    <div>
                                        <label>
                                            {{l10nEmail}}:
                                            <br>
                                            <input type="email" autofocus v-model="user.data.email"/>
                                        </label>
                                        <div v-if="shouldEmailHintBeShowing">
                                            <div class="hint-container">
                                                <div class="hint">
                                                    <span>{{l10nInvalidEmail}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="password-input">
                                        <label>
                                            {{passwordLabel}}:
                                            <br>
                                            <input type="password" v-model="user.data.password"/>
                                        </label>
                                        <div v-if="shouldPasswordHintBeShowing">
                                            <div class="hint-container">
                                                <div class="hint">
                                                    <span>{{l10nInvalidPassword}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="already-registered-container">
                                        <span class="switch-question">{{switchQuestion}}</span>
                                        <span class="switch-action" v-on:click="toggleMode()">
                                            {{switchAction}}
                                        </span>
                                    </div>
                                    <div class="continue-button-container">
                                        <jabra-btn :type="'submit'" dark>
                                            <div class="submit-button-content-container">
                                                <span v-if="isLoading" class="spinner">
                                                    <font-awesome-icon :icon="['fal', 'spinner-third']" spin/>
                                                </span>
                                                <span v-else>{{submitButtonText}}</span>
                                            </div>
                                        </jabra-btn>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </transition>
</template>

<script>

    import http from '../services/axios'
    import lodash from '../services/lodash'
    import {
        LOADING_PRISTINE,
        LOADING_STARTED,
        LOADING_COMPLETED_SUCCESS,
        LOADING_COMPLETED_FAILURE,
        SET_SESSION,
        LOAD_USER,
        LOAD_USER_ATTRIBUTES,
        LOG_IN_MODE,
        SIGN_UP_MODE,
        SET_SIGNUP_SHOW_STATE,
        SET_SIGNUP_MODE,
        ATTACH_GOOGLE_PLATFORM_AUTH_2_TO_ELEMENT,
        AUTHENTICATE_WITH_FACEBOOK,
        REF_BUTTON,
        SET_GOOGLE_LOGIN_STATE,
        LOAD_USER_EVENTS,
    } from '../services/constants'
    import helpers from '../services/helpers'


    export default {
        name: 'jabra-signup',
        data: function () {
            return {
                user: {
                    state: LOADING_PRISTINE,
                    data: null,
                    error: null,
                },
                userTemplate: {
                    email: '',
                    password: '',
                },
                formTouched: false
            }
        },
        computed: {
            title() {
                return this.mode === SIGN_UP_MODE ? this.l10nSignUp : this.l10nLogin
            },
            passwordLabel() {
                return this.mode === SIGN_UP_MODE ? this.l10nCreateAPassword : this.l10nPassword
            },
            switchQuestion() {
                return this.mode === SIGN_UP_MODE ? this.l10nAlreadyRegisteredQuestion : this.l10nDontHaveAnAccountQuestion
            },
            switchAction() {
                return this.mode === SIGN_UP_MODE ? this.l10nLogin : this.l10nCreateAnAccount
            },
            submitButtonText() {
                if (this.mode === SIGN_UP_MODE) {
                    return this.l10nContinue
                }
                if (this.user.state === LOADING_COMPLETED_FAILURE) {
                    return this.l10nTryAgain
                }
                return this.l10nLogin
            },
            isLoading() {
                return this.user.state === LOADING_STARTED
            },
            isShowing() {
                return this.$store.state.signUpState.showState
            },
            mode() {
                return this.$store.state.signUpState.mode
            },
            isUsernameValid() {
                if (this.user.data) {
                    return this.user.data.email.length > 2 && this.user.data.email.includes('@')
                }
                return false
            },
            isPasswordValid() {
                if (this.user.data) {
                    return this.user.data.password.length > 2
                }
                return false
            },
            isFormValid() {
                return this.isUsernameValid && this.isPasswordValid
            },
            shouldEmailHintBeShowing() {
                return !this.isUsernameValid && this.formTouched
            },
            shouldPasswordHintBeShowing() {
                return !this.isPasswordValid && this.formTouched
            },
            l10nLogin() {
                return this.l10nGetter('login')
            },
            l10nSignUp() {
                return this.l10nGetter('sign_up')
            },
            l10nPassword() {
                return this.l10nGetter('password')
            },
            l10nCreateAPassword() {
                return this.l10nGetter('create_a_password')
            },
            l10nOr() {
                return this.l10nGetter('or')
            },
            l10nAlreadyRegisteredQuestion() {
                return this.l10nGetter('already_registered_question')
            },
            l10nDontHaveAnAccountQuestion() {
                return this.l10nGetter('dont_have_an_account_question')
            },
            l10nCreateAnAccount() {
                return this.l10nGetter('create_an_account')
            },
            l10nLogInWith() {
                return this.l10nGetter('log_in_with')
            },
            l10nEmail() {
                return this.l10nGetter('email')
            },
            l10nInvalidEmail() {
                return this.l10nGetter('invalid_email')
            },
            l10nInvalidPassword() {
                return this.l10nGetter('invalid_password')
            },
            l10nContinue() {
                return this.l10nGetter('continue')
            },
            l10nTryAgain() {
                return this.l10nGetter('try_again')
            },
            googleSignInButtonRefName() {
                return 'googleSignInButton'
            },
            buttonRefForAttachingGoogleHandler() {
                return REF_BUTTON
            },
            googleLoginState() {
                return this.$store.state.integrationsModule.google.login
            },
            isGoogleLoginLoading() {
                return this.googleLoginState.state === LOADING_STARTED
            },
            facebookLoginState() {
                return this.$store.state.integrationsModule.facebook.login
            },
            isFacebookLoginLoading() {
                return this.facebookLoginState.state === LOADING_STARTED
            },

        },
        watch: {
            isShowing(newVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        const ref = this.$refs[this.googleSignInButtonRefName]
                            .$refs[this.buttonRefForAttachingGoogleHandler]
                        this.attachGoogleAuth2(ref)
                    })
                }
            }
        },
        methods: {
            handleSubmit() {
                this.formTouched = true
                if (this.isFormValid) {
                    this.mode === SIGN_UP_MODE ? this.signUp() : this.login()
                }
            },
            signUp() {
                const signUpObj = {
                    emailAddress: this.user.data.email,
                    password: this.user.data.password,
                }
                this.user.state = LOADING_STARTED
                http.post(`users`, signUpObj).then(results => {
                    this.login()
                }).catch(err => {
                    this.user.state = LOADING_COMPLETED_FAILURE
                    this.user.err = err
                })

            },
            login() {
                const loginObj = {
                    username: this.user.data.email,
                    password: this.user.data.password,
                }
                this.user.state = LOADING_STARTED
                http.post(`sessions`, loginObj).then(response => {
                    console.log(response.data)
                    if (response.data.success) {
                        loginObj['email'] = this.user.data.email
                        http.postToAppServer(loginObj)
                        this.setSessionCookie({
                            state: LOADING_COMPLETED_SUCCESS,
                            data: response.data.token,
                            error: null,
                        })
                        this.onLoginSuccess()
                    } else {
                        this.user.state = LOADING_COMPLETED_FAILURE
                        this.user.err = new Error('Incorrect login')
                    }
                }).catch(err => {
                    console.log(err)
                    this.user.state = LOADING_COMPLETED_FAILURE
                    this.user.err = err
                })
            },
            resetForm() {
                this.user = {
                    state: LOADING_PRISTINE,
                    data: lodash.cloneDeep(this.userTemplate),
                    error: null,
                }
                this.formTouched = false
            },
            setSessionCookie(tokenStr) {
                this.$store.commit(SET_SESSION, tokenStr)
            },
            getUserData() {
                this.$store.dispatch(LOAD_USER)
                this.$store.dispatch(LOAD_USER_ATTRIBUTES)
                this.$store.dispatch(LOAD_USER_EVENTS)
            },
            close() {
                this.resetForm()
                this.$store.commit(SET_SIGNUP_SHOW_STATE, false)
            },
            toggleMode() {
                this.$store.commit(SET_SIGNUP_MODE, this.mode === SIGN_UP_MODE ? LOG_IN_MODE : SIGN_UP_MODE)
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
            attachGoogleAuth2(ref) {
                this.$store.dispatch(ATTACH_GOOGLE_PLATFORM_AUTH_2_TO_ELEMENT, ref).then(() => {
                    this.onLoginSuccess()
                }).catch(err => {
                    this.onLoginError(err)
                })
            },
            onFacebookLoginButtonClick() {
                this.$store.dispatch(AUTHENTICATE_WITH_FACEBOOK).then(() => {
                    this.onLoginSuccess()
                }).catch(err => {
                    this.onLoginError(err)
                })
            },
            onGoogleLoginButtonClick() {
                this.$store.commit(SET_GOOGLE_LOGIN_STATE, {
                    state: LOADING_STARTED,
                    data: null,
                    error: null,
                })
            },
            onLoginSuccess() {
                this.getUserData()
                this.resetForm()
                this.close()
            },
            onLoginError(err) {
                console.error(err)
            }
        },
        created() {
            this.resetForm()
        },
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .root-animation-div {
        position: absolute;
        z-index: 1;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .modal-container {
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(255, 255, 255); /* Fallback color */
        background-color: rgba(255, 255, 255, 0.8); /* Black w/ opacity */
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .horizontal {
        display: flex;
        justify-content: center;
    }

    .modal-content {
        background-color: #fefefe;
        /*margin: 15% auto; !* 15% from the top and centered *!*/
        width: 500px; /* Could be more or less, depending on screen size */
        box-shadow: 0 0 20px 13px $grey-3;
        padding: 42px 0 0 0;
    }

    .title {
        @include font-abraham(50px, $font-color-blue, 400);
        display: flex;
        justify-content: center;
    }

    .header {
        border-bottom: $grey-3 solid 1px;
    }

    .log-in-with {
        display: flex;
        justify-content: center;
        @include font-abraham(24px, $font-color-blue, 400);
    }

    .social-login-buttons {
        display: flex;
        justify-content: space-around;
        padding: 25px 0;
    }

    .social-login-button-text {
        font-size: 20px;
        min-width: 75px;
        padding: 7px;
    }

    .divider-container {
        display: flex;
        justify-content: center;
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .body {
        @include font-abraham(24px, $font-color-blue, 400);
        padding: 23px;
        > div {
            display: flex;
            justify-content: center;
            form {
                width: 100%;
                label {
                    @include font-abraham(15px, $grey-1, 400);

                }
                input {
                    width: 100%;
                    border: #cccccc solid 1px;
                    line-height: 58px;
                    transition: border-width 0.2s linear;
                    &:focus {
                        border-bottom-width: 4px;
                    }
                }
                .password-input {
                    margin: 30px 0 0 0;
                }
            }
        }
    }

    .hint-container {
        margin: 5px 0 0 0;
    }

    .hint {
        @include font-abraham(13px, $warning-1, 300);
    }

    .already-registered-container {
        display: flex;
        justify-content: center;
        padding: 10px;
        @include font-abraham(15px, $grey-1, 400);
    }

    .continue-button-container {
        display: flex;
        justify-content: center;
        padding: 30px;
        div {
            font-size: 20px;
            padding: 7px;
        }
    }

    .switch-question {
        margin: 0 3px 0 0;
    }

    .switch-action {
        cursor: pointer;
        text-decoration: underline;
    }

    .submit-button-content-container {
        min-width: 80px;
    }

    .spinner {
        font-size: 20px;
    }


</style>
